module.exports = __webpack_public_path__ + "static/media/army.44a5ae6c.svg";